import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { InstituteService } from 'src/app/Services/institute.service';
@Component({
  selector: 'app-institute-dashboard',
  templateUrl: './institute-dashboard.component.html',
  styleUrls: ['./institute-dashboard.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ]
})


export class InstituteDashboardComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  isExpanded = true;
  isShowing = false;

  constructor(
    private router: Router,
    private service: InstituteService
    ) {
  };

  ngOnInit(): void {
    this.getMessages();
  }

  dashboardMenu: any = 'Institute';
  Institute: any;
  Student: any;
  Gap: any;
  messages:any=[];

  menuToggle(check) {
    if (check == 'Home') {
      this.router.navigateByUrl('/institute')
      .then(()=>{
        window.location.reload();
      });
    } else if (check == 'Institute') {
      this.dashboardMenu = 'Institute';
    } else if (check == 'Student') {
      this.dashboardMenu = 'Student';
    } else {
      this.dashboardMenu = 'Gap';
    }
  }

  getMessages() {
    this.service.getAllMessages(5).subscribe(data => this.setMessages(data));
  }

  setMessages(data) {
    this.messages = []
    for (let i = 0; i < data['messages'].length; i++) {
        this.messages.push(data['messages'][i])
    }
  }
}

